export const updateUserUid = (value) => ({
  type: "UPDATE_USER_UID",
  value: value,
});
export const updateUserName = (value) => ({
  type: "UPDATE_USER_NAME",
  value: value,
});
export const updateUserUsername = (value) => ({
  type: "UPDATE_USER_USERNAME",
  value: value,
});
export const updateUserEmail = (value) => ({
  type: "UPDATE_USER_EMAIL",
  value: value,
});
export const updateUserProfileImage = (value) => ({
  type: "UPDATE_USER_PROFILE_IMAGE",
  value: value,
});
export const updateUserWallet = (value) => ({
  type: "UPDATE_USER_WALLET",
  value: value,
});
export const updateUserFavorites = (value) => ({
  type: "UPDATE_USER_FAVORITES",
  value: value,
});
export const updateUserMetamaskAccount = (value) => ({
  type: "UPDATE_USER_METAMASK_ACCOUNT",
  value: value,
});
export const updateUserCollections = (value) => ({
  type: "UPDATE_USER_COLLECTIONS",
  value: value,
});
export const resetUser = () => ({
  type: "USER_RESET",
});
export const updateCelebData = (value) => ({
  type: "UPDATE_CELEB_DATA",
  value: value,
});
export const updateActiveCelebData = (value) => ({
  type: "UPDATE_ACTIVE_CELEB_DATA",
  value: value,
});
export const showBannerModal = () => ({
  type: "SHOW_BANNER_MODAL",
});
export const hideBannerModal = () => ({
  type: "HIDE_BANNER_MODAL",
});
export const addBannerDelay = () => ({
  type: "ADD_BANNER_DELAY",
});
export const removeBannerDelay = () => ({
  type: "REMOVE_BANNER_DELAY",
});
export const updateActiveCelebId = (value) => ({
  type: "UPDATE_ACTIVE_CELEB_ID",
  value: value,
});
export const showSearchWindow = () => ({
  type: "SHOW_SEARCH_WINDOW",
});
export const hideSearchWindow = () => ({
  type: "HIDE_SEARCH_WINDOW",
});
export const showSidePanelWindow = () => ({
  type: "SHOW_SIDE_PANEL_WINDOW",
});
export const hideSidePanelWindow = () => ({
  type: "HIDE_SIDE_PANEL_WINDOW",
});
export const updateActiveImage = (value) => ({
  type: "UPDATE_ACTIVE_IMAGE",
  value: value,
});
export const showAccountUpdated = () => ({
  type: "SHOW_ACCOUNT_UPDATED",
});
export const hideAccountUpdated = () => ({
  type: "HIDE_ACCOUNT_UPDATED",
});
export const loginAdmin = () => ({
  type: "LOGIN_ADMIN",
});
export const logoutAdmin = () => ({
  type: "LOGOUT_ADMIN",
});
export const addAdminError = () => ({
  type: "ADD_ADMIN_ERROR",
});
export const removeAdminError = () => ({
  type: "REMOVE_ADMIN_ERROR",
});
export const adminLoginValid = () => ({
  type: "ADMIN_LOGIN_VALID",
});
export const adminLoginNotValid = () => ({
  type: "ADMIN_LOGIN_NOT_VALID",
});
export const sidebarOpen = () => ({
  type: "ADMIN_PANEL_SIDEBAR_OPEN",
});
export const sidebarClose = () => ({
  type: "ADMIN_PANEL_SIDEBAR_CLOSE",
});
export const sidebarToggle = () => ({
  type: "ADMIN_PANEL_SIDEBAR_TOGGLE",
});
export const setAboutImageDetailsToggle = (value) => ({
  type: "SET_ABOUT_IMAGE_DETAILS_TOGGLE",
  value: value,
});
export const toggleMenuBar = () => ({
  type: "MENU_BAR_TOGGLE",
});
export const toggleSideBar = () => ({
  type: "PROFILE_SIDEBAR_TOGGLE",
});
export const updateAccountTab = (value) => ({
  type: "UPDATE_ACCOUNT_TAB",
  value: value,
});
export const showWalletMenuBar = () => ({
  type: "SHOW_WALLET_MENU_BAR",
});
export const hideWalletMenuBar = () => ({
  type: "HIDE_WALLET_MENU_BAR",
});
export const updateAdminActiveCelebList = (value) => ({
  type: "UPDATE_ADMIN_ACTIVE_CELEB_LIST",
  value: value,
});
export const updateActiveAdminDashboard = (value) => ({
  type: "UPDATE_ACTIVE_ADMIN_DASHBOARD",
  value: value,
});
export const updateAdminSuccessMsg = (value) => ({
  type: "UPDATE_ADMIN_SUCCESS_MSG",
  value: value,
});
export const updateAdminErrorMsg = (value) => ({
  type: "UPDATE_ADMIN_ERROR_MSG",
  value: value,
});
export const startBidding = (value) => ({
  type: "START_BIDDING",
  value: value,
});
export const stopBidding = (value) => ({
  type: "STOP_BIDDING",
  value: value,
});
export const toggleNotification = () => ({
  type: "TOGGLE_NOTIFICATION",
});
